export default "__VITE_ASSET__DBuUN1oF__"